<template>
  <ls-table-layout>
    <template #search>
      <SearchForm
        ref="searchFormRef"
        @search="onSearch"
        :activeStateKey="activeStateKey"
        @toggleAdvanced="onToggleAdvanced"
      />
    </template>
    <template #tabs>
      <ls-button-group
        ref="statesTabsRef"
        :current="activeStateKey"
        :button-item="STATUS_CODE_TAB_V_LIST"
        type="tabs"
        @select="onTabChange"
      >
      </ls-button-group>
    </template>
    <div class="table-page-operator-wrapper" slot="btn">
      <span v-show="activeStateKey === PLAN_STATUS.CREATE.lookupCode">
        <!-- <a-button
          key="scp:scpSopPurchasePlanPool:add"
          @click="onAddBill"
          type="primary"
          v-hasPermi="['scp:scpSopPurchasePlanPool:add']"
        >新增</a-button> -->
        <a-button
          key="scp:scpSopPurchasePlanPool:submit"
          @click="onSubmit"
          :loading="btnLoading"
          type="primary"
          v-hasPermi="['scp:scpSopPurchasePlanPool:submit']"
        >提交</a-button>
        <a-button
          key="scp:scpSopPurchasePlanPool:deleteBatch"
          @click="onRemove"
          :loading="btnLoading"
          type="danger"
          v-hasPermi="['scp:scpSopPurchasePlanPool:deleteBatch']"
        >删除</a-button>
        <a-button
          key="scp:scpSopPurchasePlanPool:import"
          @click="importExcelHandleOpen"
          v-hasPermi="['scp:scpSopPurchasePlanPool:import']"
        >导入</a-button>
      </span>
      <span v-show="activeStateKey === PLAN_STATUS.AUDITING.lookupCode">
        <a-button
          key="scp:scpSopPurchasePlanPool:audit"
          @click="onAudit"
          :loading="btnLoading"
          type="primary"
          v-hasPermi="['scp:scpSopPurchasePlanPool:audit']"
        >审核</a-button>
        <a-button
          key="scpp:monthPlanPool:batchClose"
          @click="onShowRejectModal"
          :loading="btnLoading"
          type="danger"
        >驳回</a-button>
      </span>
      <span v-show="PLAN_STATUS.AUDITED.lookupCode === activeStateKey">
        <a-button
          key="	scp:scpSopPurchasePlanPool:delivery"
          @click="onPublish"
          :loading="btnLoading"
          type="primary"
          v-hasPermi="['scp:scpSopPurchasePlanPool:delivery']"
        >发放计划单</a-button>
        <a-button
          key="scpp:monthPlanPool:anAudit"
          @click="onAntiAudit"
          :loading="btnLoading"
          type="danger"
        >反审核</a-button>
        <a-button
          key="scp:scpSopPurchasePlanPool:cancel1"
          @click="onInvalidate"
          :loading="btnLoading"
          type="danger"
          v-hasPermi="['scp:scpSopPurchasePlanPool:cancel']"
        >作废</a-button>
      </span>
      <span v-show="PLAN_STATUS.RELEASED.lookupCode === activeStateKey">
        <!-- <a-button
          key="scp:scpSopPurchasePlanPool:ensureLS"
          v-hasPermi="['scp:scpSopPurchasePlanPool:ensureLS']"
          @click="onSign"
          :loading="btnLoading"
          type="primary"
        >签署</a-button> -->
        <a-button
          key="scp:scpSopPurchasePlanPool:createPurchaseDemand"
          @click="onShowCreatePurchaseRequirementModal"
          :loading="btnLoading"
          type="primary"
          v-hasPermi="['scp:scpSopPurchasePlanPool:createPurchaseDemand']"
        >创建采购需求</a-button>
        <a-button
          key="scp:scpSopPurchasePlanPool:cancel"
          @click="onInvalidate"
          :loading="btnLoading"
          type="danger"
          v-hasPermi="['scp:scpSopPurchasePlanPool:cancel']"
        >作废</a-button>
        <a-button
          key="scp:scpSopPurchasePlanPool:setChangeOrder"
          @click="onCreateChange"
          :loading="btnLoading"
          type="primary"
          v-hasPermi="['scp:scpSopPurchasePlanPool:setChangeOrder']"
        >发起变更单</a-button>
        <a-button
          key="scp:scpSopPurchasePlanPool:importBillOrder"
          @click="importChangeOrder"
          :loading="btnLoading"
          v-hasPermi="['scp:scpSopPurchasePlanPool:importBillOrder']"
        >导入变更单</a-button>
        <a-button
          key="scp:scpSopPurchasePlanPool:batchUpdateItemInfo"
          @click="onBatchUpdateItemInfo"
          :loading="btnLoading"
          type="primary"
        >更新物料</a-button>
        <a-button
          key="scp:scpSopPurchasePlanPool:importPurchaseDemand"
          @click="importPurchaseRequirementHandleOpen"
          :loading="btnLoading"
          v-hasPermi="['scp:scpSopPurchasePlanPool:importPurchaseDemand']"
        >导入采购需求</a-button>
        <a-button
          key="mes:scpSopPurchasePlanPool:v2:exportPurchaseDemant"
          @click="onExportPurchaseRequirement"
          :loading="btnLoading"
          v-hasPermi="['scp:scpSopPurchasePlanPool:v2:exportPurchaseDeman']"
        >导出采购需求</a-button>
      </span>
      <span>
        <a-button
          key="scp:scpSopPurchasePlanPool:export"
          :loading="exportLoading"
          @click="handleExport"
          v-hasPermi="['scp:scpSopPurchasePlanPool:export']"
        >导出</a-button>
      </span>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <ls-api-table
          ref="baseTable"
          :columns="dyCols"
          :pagination="pagination"
          :table-props="tableProps"
          :scroll="{ fixScreen: true, x: scrollX }"
          :custom-selection="{ stickyFixed: true }"
          :selectedRows.sync="selectedRows"
          @selectedRowChange="selectedRowChange"
          @change="handleTableChange"
          :multi-select="true"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.OUTBOUND_DETAILS_LIST // 表格方案配置唯一值
              }"
        >
          <template #textEllipsis="{ text }">
            <a-tooltip :title="text"><div class="text-3-ellipsis">{{ text }}</div></a-tooltip>
          </template>
          <template #formatDateOnly="{ text }">
            <span>{{ formatDateOnly(text) }}</span>
          </template>
          <template #formatDate="{ text }">
            <span>{{ formatDate(text) }}</span>
          </template>
          <template #supplierName="{ record, text, index }">
            <global-select
              :id="record.id + '-' + index + '-supplierSelect'"
              v-if="record.editIs && activeStateKey === PLAN_STATUS.CREATE.lookupCode"
              class="supplier-select"
              :allow-clear="false"
              v-model="record.supplierCode"
              selectType="selectFilter"
              :dropdown-match-select-width="false"
              requestApi="/scp/scpSopPurchasePlanPool/querySignSupplierBySku"
              :selectItem="{ value: 'supplierCode', label: 'supplierName' }"
              :setParams="{ sku: record.itemCode, pageSize: 9999 }"
              @change="(val, list) => handleSupplierChange(val, list, record)"
            />
            <a-tooltip v-else :title="text + '-' + record.supplierCode">
              <div class="text-3-ellipsis">{{ text + '-' + record.supplierCode }}</div>
            </a-tooltip>
          </template>
          <template #planQuantity="{ record }">
            <a-input-number v-if="record.editIs" v-model="record.planQuantity" :min="0" :precision="0" />
            <span v-else>{{ record.planQuantity }}</span>
          </template>
          <template #planCycle="{ record }">
            <a-month-picker
              v-if="record.editIs"
              v-model="record.planCycle"
              valueFormat="YYYY-MM"
              format="YYYY-MM"
              allowClear
              class="full-width"
              :disabled-date="disabledDate"
              placeholder="请选择"
            />
            <template v-else>{{ record.planCycle }}</template>
          </template>
          <template #materialStatus="{ text }">
            <ls-tags v-if="MATERIAL_STATUS_NAME_MAP[text]">{{ MATERIAL_STATUS_NAME_MAP[text] }}</ls-tags>
          </template>
          <template #signStatus="{ text }">
            <ls-tags v-if="SIGN_STATUS_NAME_MAP[text]" color="#3d7a4f">{{ SIGN_STATUS_NAME_MAP[text] }}</ls-tags>
          </template>
          <template #companyRemark="{ text, record }">
            <a-input v-if="record.editIs" v-model="record.companyRemark" :maxLength="50" />
            <a-tooltip v-else :title="text"><div class="text-3-ellipsis">{{ text }}</div></a-tooltip>
          </template>
          <template #changeRecord="{ text, record }">
            <a @click="onChangeRecord(record)" href="javascript:;">查看变更记录</a>
          </template>
          <template #operation="{ record }">
            <template>
              <a-button
                v-if="!record.editIs &&
                  [
                    PLAN_STATUS.CREATE.lookupCode,
                    PLAN_STATUS.AUDITING.lookupCode,
                    PLAN_STATUS.RELEASED.lookupCode,
                    PLAN_STATUS.AUDITED.lookupCode,
                  ].includes(record.status)
                "
                v-hasPermi="['scp:scpSopPurchasePlanPool:updateFields']"
                type="link"
                class="link-btn"
                @click="() => onEdit(record, 1)"
              >编辑</a-button>
              <template v-if="record.editIs">
                <a-button
                  type="link"
                  class="link-btn"
                  :loading="record.loading"
                  @click="() => onSave(record)"
                >保存</a-button>
                <a-button
                  type="link"
                  class="link-btn"
                  :loading="record.loading"
                  @click="() => onEdit(record, 0)"
                >取消</a-button>
              </template>
            </template>
            <a-tooltip :title="record.isUnionOrder ? null : '无关联采购订单'">
              <span><a-button
                v-if="!record.editIs"
                class="link-btn"
                type="link"
                :disabled="!record.isUnionOrder"
                @click="() => onShowPurchaseOrderModal(record)"
              >关联采购订单</a-button></span>
            </a-tooltip>
            <a-button
              v-if="!record.editIs"
              class="link-btn"
              type="link"
              @click="() => handleLog(record)"
            >日志</a-button>
            <a-button
              v-if="!record.editIs"
              class="link-btn"
              :disabled="!record.contractNo"
              type="link"
              @click="() => onViewContract(record)"
            >查看合同</a-button>
          </template>
        </ls-api-table>
      </div>
      <ImportExcel
        ref="importExcelRef"
        v-bind="importData"
        @refresh="refreshList"
      />
      <ImportExcel
        ref="importPurchaseRequirementExcelRef"
        v-bind="importPurchaseRequirementData"
        @refresh="refreshList"
      />
      <ImportExcel
        ref="importChangeOrderRef"
        v-bind="importChangeOrderData"
        @refresh="refreshList"
      />
      <DownloadModal :apiFun="exportApi" ref="downloadRef" />
      <AddModal ref="addModalRef" :mainBtnLoading="btnLoading" @successCall="refreshList" />
      <OperationLogModel ref="operationLogModelRef" :logLoading="logLoading" :logList="logList" @closeLog="closeLogFun" />
      <RequirementModal ref="addRequirementModalRef" :mainBtnLoading.sync="btnLoading" @successCall="refreshList" />
      <RejectModal ref="rejectModalRef" :mainBtnLoading.sync="btnLoading" @successCall="refreshList" />
      <PurchaseOrderDrawer ref="purchaseOrderDrawerRef" :mainBtnLoading.sync="btnLoading" @successCall="refreshList" />
      <PurchaseChangeDrawer ref="purchaseChangeDrawerRef" :mainBtnLoading.sync="btnLoading" @successCall="refreshList" />
      <change-record-modal ref="changeRecordModalRef" @successCall="refreshList" />
    </template>
  </ls-table-layout>
</template>

<script>
import { generateLsTableResData, getFaDadaContractUrl } from '@/utils/util.js'
import moment from 'moment'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import SearchForm from './components/search-form.vue'
import AddModal from './components/add-modal.vue'
import ImportExcel from "@/components/ImportExcel/importExcel"
import RejectModal from './components/reject-modal.vue'
import PurchaseChangeDrawer from './components/purchase-change-drawer.vue'
import {
  formatDate,
  formatDateOnly,
  PLAN_STATUS,
  MONTH_PLAN_POOL_COLUMNS,
  MATERIAL_STATUS_NAME_MAP,
  SIGN_STATUS_NAME_MAP
} from './common'
import deepClone from 'lodash/cloneDeep'
import {
  apiExportPurchaseDemand,
  apiExportPurchasePlanPool,
  apiPurchasePlanPoolList,
  apiDeletePurchasePlanPool,
  apiUpdatePurchasePlanPool,
  apiSubmitPurchasePlanPool,
  apiAuditPurchasePlanPool,
  apiDeliveryPurchasePlanPool,
  apiCancelPurchasePlanPool,
  apiGetSignContractUrl,
  getPurchasePlanPoolLogApi,
  apiGetTemplate,
  apiGetPurchaseDemandTemplate,
  apiBatchUpdateItemInfo
} from '@/api/scp/month-plan-pool/month-plan-pool'
import OperationLogModel from '@/components/operation-log/operation-log-model.vue'
import RequirementModal from './components/requirement-modal.vue'
import PurchaseOrderDrawer from './components/purchase-order-drawer.vue'
import changeRecordModal from "./components/change-record-modal.vue"
export default {
  name: 'MonthPlanPool',
  components: {
    OperationLogModel,
    AddModal,
    DownloadModal,
    SearchForm,
    ImportExcel,
    RequirementModal,
    RejectModal,
    PurchaseChangeDrawer,
    changeRecordModal,
    PurchaseOrderDrawer
  },
  data() {
    return {
      // 表格多选
      selectedRowKeys: [],
      pagination: {
        pageSizeOptions: ["10", "20", "50", "100", "500"]
      },
      selectedRows: [],
      activeStateKey: PLAN_STATUS.CREATE.lookupCode,
      btnLoading: false,
      exportLoading: false,
      exportApi: null,
      logLoading: false,
      logList: [],
      importData: {
        // 用户导入参数
        uploadParams: {
          url: process.env.VUE_APP_API_BASE_URL + '/scp/scpSopPurchasePlanPool/import' // 上传的地址
        },
        // 导入模板下载参数
        downloadParams: {
          downloadApi: () => {
            this.onDownloadTemplate()
          },
          url: 'scp/scpSopPurchasePlanPool/template',
          name: `月度计划池导入模板_${moment().format('YYYY-MM-DD')}.xlsx`
        }
      },
      importPurchaseRequirementData: {
        uploadParams: {
          url: process.env.VUE_APP_API_BASE_URL + '/scp/scpSopPurchasePlanPool/importPurchaseDemand' // 上传的地址
        },
        downloadParams: {
          downloadApi: () => {
            this.onDownPurchaseDemandTemplate()
          },
          url: 'scp/scpSopPurchasePlanPool/purchaseDemandTemplate',
          name: `采购需求信息导入模板_${moment().format('YYYY-MM-DD')}.xlsx`
        }
      },
      importChangeOrderData: {
        uploadParams: {
          url: process.env.VUE_APP_API_BASE_URL + '/scp/scpSopPurchasePlanPool/importConfirmPlanPoolChangeBill' // 上传的地址
        },
        downloadParams: {
          method: 'post',
          url: 'scp/scpSopPurchasePlanPool/changeBillImportTemplate',
          name: `变更单导入模板_${moment().format('YYYY-MM-DD')}.xlsx`
        }
      },
      // 表格字段
      dyCols: MONTH_PLAN_POOL_COLUMNS
    }
  },
  computed: {
    scrollX() {
      return this.dyCols.reduce((acc, cur) => {
        return acc + (cur.width || 140)
      }, 220)
    },
    PLAN_STATUS() {
      return PLAN_STATUS;
    },
    tableProps() {
      return {
        requestApi: generateLsTableResData(apiPurchasePlanPoolList),
        pageCurrent: false
      }
    },
    STATUS_CODE_TAB_V_LIST() {
      return Object.values(PLAN_STATUS).map(item => ({
        id: item.lookupCode, name: item.lookupValue
      }));
    },
    canEditIs() {
      return (record) => {
        return record.editIs
      }
    },
    MATERIAL_STATUS_NAME_MAP() {
      return MATERIAL_STATUS_NAME_MAP
    },
    SIGN_STATUS_NAME_MAP() {
      return SIGN_STATUS_NAME_MAP
    }
  },
  mounted() {
    this.$refs.searchFormRef.handleSearch();
  },
  methods: {
    // 查看变更记录
    onChangeRecord(row) {
      console.log(row);
      this.$refs.changeRecordModalRef.show(row);
    },
    // table排序等
    handleTableChange (pagination, filters, sorter) {
      let obj = {}
      const params = this.$refs.baseTable.searchParams
      if(sorter?.order && sorter?.columnKey) {
        obj = {
          orderByColumn: sorter.columnKey,
          isAsc: sorter.order === "ascend" ? 'asc' : 'desc'
        }
        this.$refs.baseTable.searchParams = deepClone({ ...params, ...obj });
      } else {
        if (params?.orderByColumn) {
          delete params.orderByColumn
          delete params.isAsc
          this.$refs.baseTable.searchParams = params
        }
      }
    },
    // 发起变更单
    onCreateChange() {
      if(this.selectedRows?.length === 0) {
        return this.$message.warning("请至少勾选一条单据进行操作")
      }
      if(this.selectedRows?.length > 1) {
        const supplierCode = this.selectedRows[0].supplierCode;
        if(this.selectedRows.some(item => item.supplierCode !== supplierCode)) {
          return this.$message.warning("请选择相同供应商的采购单进行操作")
        }
      }
      this.$refs.purchaseChangeDrawerRef.show(this.selectedRows);
    },
    // 获取采购需求模板
    onDownPurchaseDemandTemplate() {
      apiGetPurchaseDemandTemplate().then(res => {
        const sufffix = res.data.split('.').pop()
        this.downloadByJson(res.data, {}, `采购需求信息导入模板_${moment().format('YYYY-MM-DD')}.${sufffix}`, { method: 'get' })
      })
    },
    onDownloadTemplate() {
      apiGetTemplate().then(res => {
        const sufffix = res.data.split('.').pop()
        this.downloadByJson(res.data, {}, `月度计划池导入模板_${moment().format('YYYY-MM-DD')}.${sufffix}`, { method: 'get' })
      })
    },
    onViewContract(row) {
      const { contractNo } = row;
      if(contractNo) {
        window.open(
          getFaDadaContractUrl(contractNo),
          '_blank'
        );
      }
    },
    onSign() {
      if(this.selectedRows.length === 0) {
        return this.$message.warning("请至少勾选一条单据进行操作")
      }
      const params = {
        planNo: this.selectedRows[0].planNo,
        returnUrl: location.origin + '/view/signSuccess.html'
      }
      this.btnLoading = true
      apiGetSignContractUrl(params).then(res => {
        if (res.code === 200 && res.data) {
          const a = window.open(
            res.data.data,
            "_blank",
            "height=" +
            window.innerHeight +
            ",width=" +
            window.innerWidth +
            ",status=yes,top=0,left=0,toolbar=no,menubar=no,location=no"
          );
          a.moveTo(0, 0);
        }
      }).finally(() => {
        this.btnLoading = false;
      });
    },
    sginComplete() {
      this.refreshList(true)
    },
    // 导出采购需求
    onExportPurchaseRequirement() {
      if(this.selectedRows.length === 0) {
        return this.$message.warning("请至少勾选一条单据进行操作")
      }
      this.exportApi = apiExportPurchaseDemand;
      const params = this.selectedRows.map(item => item.id);
      this.$nextTick(() => {
        this.$refs.downloadRef.openModal(params)
      })
    },
    // 供应商选择
    handleSupplierChange(val, list, record) {
      if(val) {
        const getItem = list.find(item => item.supplierCode === val)
        record.supplierName = getItem.supplierName
      } else {
        record.supplierName = ''
      }
    },
    // 发放计划单
    onPublish() {
      if(this.selectedRows.length === 0) {
        return this.$message.warning("请至少勾选一条单据进行操作")
      }
      this.btnLoading = true
      apiDeliveryPurchasePlanPool({ ids: this.selectedRows.map(item => item.id).toString(), status: PLAN_STATUS.AUDITED.lookupCode }).then(response => {
        if (response.code === 200) {
          this.$message.success(response.data || '操作成功');
          this.refreshList()
        } else {
          this.$message.error(response.msg)
        }
      }).finally(() => {
        this.btnLoading = false
      })
    },
    // 反审核
    onAntiAudit() {
      if(this.selectedRows.length === 0) {
        return this.$message.warning("请至少勾选一条单据进行操作")
      }
      this.$confirm({
        title: '确定反审核吗？',
        okText: '确定',
        cancelText: '取消',
        onOk: () => {
          this.btnLoading = true
          apiAuditPurchasePlanPool({ ids: this.selectedRows.map(item => item.id), status: PLAN_STATUS.AUDITING.lookupCode }).then(response => {
            if (response.code === 200) {
              this.$message.success(response.data || '审核成功')
              this.refreshList()
            } else {
              this.$message.error(response.msg)
            }
          }).finally(() => {
            this.btnLoading = false
          })
        }
      })
    },
    // 作废
    onInvalidate() {
      if(this.selectedRows.length === 0) {
        return this.$message.warning("请至少勾选一条单据进行操作")
      }
      this.$confirm({
        title: `确认作废选中的${this.selectedRows.length}条计划单？作废后不可恢复。`,
        okText: '确定',
        cancelText: '取消',
        onOk: () => {
          this.btnLoading = true
          apiCancelPurchasePlanPool(this.selectedRows.map(item => item.id)).then(response => {
            if (response.code === 200) {
              this.$message.success(response.data || '操作成功')
              this.refreshList()
            } else {
              this.$message.error(response.msg)
            }
          }).finally(() => {
            this.btnLoading = false
          })
        }
      })
    },
    // 驳回
    onShowRejectModal() {
      if(this.selectedRows.length === 0) {
        return this.$message.warning("请至少勾选一条单据进行操作")
      }
      this.$refs.rejectModalRef.show(this.selectedRows)
    },
    // 审核
    onAudit() {
      if(this.selectedRows.length === 0) {
        return this.$message.warning("请至少勾选一条单据进行操作")
      }
      this.btnLoading = true
      apiAuditPurchasePlanPool({ ids: this.selectedRows.map(item => item.id), status: PLAN_STATUS.AUDITED.lookupCode }).then(response => {
        if (response.code === 200) {
          this.$message.success(response.data || '审核成功')
          this.refreshList()
        } else {
          this.$message.error(response.msg)
        }
      }).finally(() => {
        this.btnLoading = false
      })
    },
    // 删除
    onRemove() {
      if(this.selectedRows.length === 0) {
        return this.$message.warning("请至少勾选一条单据进行操作")
      }
      this.$confirm({
        title: '确定删除吗？',
        okText: '确定',
        cancelText: '取消',
        onOk: () => {
          this.btnLoading = true
          apiDeletePurchasePlanPool(this.selectedRows.map(item => item.id)).then(response => {
            if (response.code === 200) {
              this.$message.success(response.data || '删除成功')
              this.refreshList()
            } else {
              this.$message.error(response.msg)
            }
          }).finally(() => {
            this.btnLoading = false
          })
        }
      })
    },
    // 提交
    onSubmit() {
      if(this.selectedRows.length === 0) {
        return this.$message.warning("请至少勾选一条单据进行操作")
      }
      this.btnLoading = true
      apiSubmitPurchasePlanPool({ ids: this.selectedRows.map(item => item.id).toString() }).then(response => {
        if (response.code === 200) {
          this.$message.success(response.data || '提交成功')
          this.refreshList()
        } else {
          this.$message.error(response.msg)
        }
      }).finally(() => {
        this.btnLoading = false
      })
    },
    formatDate,
    formatDateOnly,
    /** 导入excel窗体开启 */
    importExcelHandleOpen() {
      this.$refs.importExcelRef.show()
    },
    importPurchaseRequirementHandleOpen() {
      this.$refs.importPurchaseRequirementExcelRef.show()
    },
    // 导入变更单
    importChangeOrder() {
      this.$refs.importChangeOrderRef.show()
    },
    // 关联采购订单
    onShowPurchaseOrderModal(record) {
      this.$refs.purchaseOrderDrawerRef.show(record);
    },
    // 创建采购需求
    onShowCreatePurchaseRequirementModal() {
      if(this.selectedRows.length !== 1) {
        return this.$message.warning("请勾选一条单据进行操作")
      }
      this.$refs.addRequirementModalRef.show(this.selectedRows[0]);
    },
    /** 行选中 */
    selectedRowChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    // $lookupMeaning(operationTypeList, record.operationType)
    onTabChange(list) {
      this.activeStateKey = list[0].id;
      this.selectedRows = [];
      this.refreshList();
    },
    onSave(record) {
      const checkMap = {
        planCycle: '计划周期',
        planQuantity: '计划数量'
        // companyRemark: '林氏备注'
      }
      const errorList = [];
      const errorList2 = [];
      for(const field in checkMap) {
        if(field === 'planQuantity') {
          if(record.planQuantity === 0) {
            errorList2.push('计划数量不能为0');
          }else if(!record.planQuantity) {
            errorList.push(checkMap[field]);
          }
        }else if(Array.isArray(record[field]) && !record[field].length) {
          errorList.push(checkMap[field]);
        }else if(!record[field]) {
          errorList.push(checkMap[field]);
        }
      }
      if(errorList?.length || errorList2?.length) {
        (errorList2.length && this.$message.warning(errorList2.join(',')));
        (errorList.length && this.$message.error(errorList.join(',') + '未填写'));
        return;
      }
      const {
        id,
        planCycle,
        planQuantity,
        supplierCode,
        supplierName,
        companyRemark
      } = record;
      const params = {
        id,
        planCycle,
        planQuantity,
        supplierCode,
        supplierName,
        companyRemark
      }
      this.$set(record, 'loading', true);
      apiUpdatePurchasePlanPool(params).then(response => {
        if (response.code === 200) {
          this.$message.success('操作成功')
          this.refreshList(true);
        } else {
          this.$message.error(response.msg)
        }
      }).finally(() => {
        this.$set(record, 'loading', false);
      })
    },
    onEdit(record, editStatus) {
      if(editStatus) {
        record.tempRow = deepClone(record);
      }else {
        const tempRow = record.tempRow;
        for (const item in record) {
          record[item] = tempRow[item];
        }
        delete record.tempRow;
      }
      this.$set(record, 'editIs', editStatus);
    },
    // 新建
    onAddBill() {
      this.$refs.addModalRef.show()
    },
    onSearch(params) {
      const newParams = { ...params };
      if(this.activeStateKey !== PLAN_STATUS.ALL.lookupCode) {
        newParams.status = this.activeStateKey;
      }
      // 排序
      const historyParams = this.$refs.baseTable.searchParams
      if (historyParams?.orderByColumn) { newParams.orderByColumn = historyParams.orderByColumn }
      if (historyParams?.isAsc) { newParams.isAsc = historyParams.isAsc }
      this.$refs.baseTable.searchParams = newParams;
      this.$refs.baseTable.getData(this.currentPageIs)
      this.currentPageIs = false
    },
    refreshList(currentPageIs) {
      this.$nextTick(() => {
        this.currentPageIs = !!currentPageIs
        this.$refs.searchFormRef.handleSearch()
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      this.exportApi = apiExportPurchasePlanPool;
      const params = this.$refs.baseTable.searchParams;
      this.$nextTick(() => {
        this.$refs.downloadRef.openModal(params)
      })
    },
    onToggleAdvanced() {
      setTimeout(() => {
        this.$refs.baseTable.initScrollY();
      }, 100)
    },
    disabledDate(current) {
      return current < this.$moment().startOf('month');
    },
    // 关闭日志弹窗
    closeLogFun() {
      this.logLoading = false;
      this.logList = [];
    },
    // 操作日志弹窗
    handleLog(row) {
      this.logList = []
      this.logLoading = true
      this.$refs.operationLogModelRef.show();
      getPurchasePlanPoolLogApi({ id: row.id, type: 12 }).then(res => {
        if (res.code === 200) {
          if (res?.data?.length > 0) { this.logList = res.data }
        }
      }).finally(() => {
        this.logLoading = false
      })
    },
    // 批量更新物料信息
    onBatchUpdateItemInfo() {
      if(this.selectedRows.length === 0) {
        return this.$message.warning("请至少勾选一条单据进行操作")
      }
      this.$confirm({
        title: '确定要更新选中的物料信息吗？',
        content: `将更新${this.selectedRows.length}条记录的物料信息`,
        okText: '确定',
        cancelText: '取消',
        onOk: () => {
          this.btnLoading = true
          const ids = this.selectedRows.map(item => item.id)
          apiBatchUpdateItemInfo({ ids }).then(response => {
            if (response.code === 200) {
              this.$message.success(response.data || '物料信息更新成功')
              this.refreshList()
            } else {
              this.$message.error(response.msg)
            }
          }).finally(() => {
            this.btnLoading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.link-btn {
  height: unset;
  padding: 0 4px;
  button {
    height: unset;
  }
}
.text-3-ellipsis {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}
/deep/.ant-input-number {
  width: 100%;
}
.select-width-130 {
  /deep/.ant-select {
    width: 120px;
  }
}
.error-border {
  border-color: #ff0000;
  /deep/.ant-select-selection {
    border-color: #ff0000;
  }
}
.error-text {
  font-size: 11px;
  color: #ff0000;
}
.action-icon{
  cursor: pointer;
  font-size: 14px;
  color: #0486fe;
}
.supplier-select{
  /deep/ .ant-select {
    width: 100%;
  }
}
</style>
